<template>
  <div class="content-wrapper">
    <app-overlay-loader v-if="preloader" />
    <div :class="{ 'loading-opacity': preloader }">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          :page-title="$t('Toma de Decisión')"
          :directory="$t('')"
          :icon="'trello'"
        />
      </div>

      <div class="col-sm-12 col-md-6">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
          <button
            type="button"
            class="btn btn-primary btn-with-shadow"
            @click="returnPage()"
          >
            {{ $t("back") }}
          </button>
          <button
          v-if="showProces"
            type="button"
            class="btn btn-success btn-with-shadow ml-3"
            @click="openDeleteModal"
          >
            Procesar
          </button>
        </div>
      </div>

    </div>
    <div class="row">
              <div class="col-12">
          <legend class="col-form-label text-primary pt-0 mb-3">
            <h5>Evaluaciones</h5>
          </legend>
        </div>
        <div class="col-12">
          <table class="table table-sm table-striped">
            <thead>
              <tr>
                <th scope="col">Expediente</th>
                <th scope="col">Tipo</th>
                <th scope="col">Código</th>
                <th scope="col">Estado</th>
                <th scope="col" class="text-center" style="width: 10%">
                  Documento
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(value, key) in evaluations" :key="key">
                <td class="align-middle">
                  {{ value.accreditation_applications.record }}
                </td>
                <td class="align-middle">
                  <p v-if="value.type == 'E'">Evaluación</p>
                  <p v-if="value.type == 'T'">Testificación</p>
                </td>
                <td class="align-middle">{{ value.code }}</td>
                <td class="align-middle">
                  {{ value.status.name }}
                  <small class="text-success" v-if="value.status.code == 600"
                    >(Finalizado)</small
                  >
                  <small class="text-danger" v-if="value.status.code != 600"
                    >(En proceso)</small
                  >
                </td>
                <td class="align-middle text-center">
                  <button
                    type="submit"
                    class="btn btn-success"
                    @click.prevent="openModal(value)"
                  >
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
    </div>

    <div class="row" v-if="isVisibleDraftReport">
      <div class="col-md-12" v-if="!tabRenovation">
        <app-tab :tabs="tabsHorizontal" type="horizontal" />
      </div>
      <div class="col-md-12" v-if="tabRenovation">
        <app-tab :tabs="tabsHorizontalSec" type="horizontal" />
      </div>
    </div>

     <app-confirmation-modal
      v-if="deleteConfirmationModalActive"
      :preloader="deleteLoader"
      modal-id="modal-confirm-id"
      @confirmed="confirmed"
      @cancelled="cancelled"
      title="Confirmación"
      message="¿Desea procesar este registro?"
      firstButtonName="Aceptar"
      secondButtonName="Cancelar"
      modalClass="success"
      icon="cpu"
    />

      <director-area-modal
        v-if="isAddEditModalActive"
        @close-modal="closeAddEditModal"
      />
      <app-confirmation-modal
        v-if="deleteModal"
        modal-id="delete"
        @confirmed="confirm"
        @cancelled="cancelled"
      />
  </div>
  </div>
</template>


<script>
import * as actions from "../../apiUrl";
import { axiosPatch , axiosGet} from "@/app/helpers/AxiosHelper";

export default {
  name: "Tabs",
  props: {
    evalTestId: String,
  },
  data() {
    return {
      icon: "settings",
      evaluations: [],
      accAppId:"",
      tabRenovation: false,
      preloader: false,
      isAddEditModalActive: false,
      showFile: false,
      deleteConfirmationModalActive: false,
      deleteLoader: false,
      deleteModal: false,
      showProces: true,
      tabsHorizontal: [
        {
          icon: "file",
          name: " Anexos ",
          component: "decision-tecnical-making-anexed",
          permission: "",
        },
        {
          icon: "activity",
          name:
            "Informe",
          component: "decision-tecnical-making-report",
          permission: "",
        },
        {
          icon: "send",
          name: "Alcances Registrados",
          component: "scopes-evaluator-index",
          permission: "",
        },
        {
          icon: "briefcase",
          name: "Devolver proceso",
          component: "return-process-index",
          permission: "",
        },
      ],
      tabsHorizontalSec: [
        {
          icon: "file",
          name: " Anexos ",
          component: "decision-tecnical-making-anexed",
          permission: "",
        },
        {
          icon: "activity",
          name:
            "Informe",
          component: "decision-tecnical-making-report",
          permission: "",
        },
        {
          icon: "send",
          name: "Alcances Registrados",
          component: "scopes-evaluator-index",
          permission: "",
        },
        {
          icon: "briefcase",
          name: "Plan de Mantenimiento",
          component: "decision-tecnical-making-maintenance",
          permission: "",
        },
        {
          icon: "briefcase",
          name: "Devolver proceso",
          component: "return-process-index",
          permission: "",
        },
      ],
    };
  },
   computed: {
    evalTest() {
      return this.$store.state.evaluatorReview
        ? this.$store.state.evaluatorReview.evalTest
        : null;
    },
     isVisibleDraftReport(){
      //status.code = 600
       return this.evaluations.every(evalItem => evalItem.status.code === "600");
     },
  },
  created() {
    this.$store.state.evaluatorReview.evalTestId = this.evalTestId;
    //console.log('this.evalTestId ' + this.evalTestId);
    
    this.dataList();
    // this.getActivity();
  },
  methods: {
    returnPage() {
      window.location.href = `/accreditationtechnical/desicionmaking`;
    },
  
    dataList() {
      this.preloader = true;
      let url = `${actions.DESICION_MAKING}/evalList/${this.evalTestId}`;
      axiosGet(url).then((response) => {
        this.evaluations = response.data.evaluations;
        this.accAppId = response.data.evaluations[0].accreditation_id;
        this.showFile = response.data.showFile;

        for (let i = 0; i < this.evaluations.length; i++) {
            if(this.evaluations[i].status.code != 600){
              this.showProces = false;
            }
        }
        axios
        .get(
          `/evaluator/documentaryEvaluation/activity/${this.accAppId}?accApp=1`
        )
        .then((res) => {
          this.$store.state.accreditation.id = res.data.id;
          this.$store.state.accreditation.app = res.data;
          this.$store.state.accreditation.currentStatus = response.data.evaluations[0].status.code;
        });
        // console.log(this.accAppId);

        if (response.data.evaluations[0].accreditation_applications.accreditation_type_id == 9 || response.data.evaluations[0].accreditation_applications.accreditation_type_id == 11) {
          this.tabRenovation = true;
        }
      })
      .finally(() => {
        setTimeout(() => {
          this.preloader = false;
      }, 3000);
      });
    },
    openDeleteModal() {
      this.deleteConfirmationModalActive = true;
    },
    confirmed() {
      let url = `${actions.DESICION_MAKING}/process?evalTestId=${this.evalTestId}`;
      this.deleteLoader = true;
      axiosPatch(url)
        .then(({ data: res }) => {
          this.deleteLoader = false;
          $("#modal-confirm-id").modal("hide");
          this.cancelled();
          if (res.data === "maintenancePlan") {
              this.$toastr.e("Llenar los datos del plan de mantenimiento");
          } else if (res.data === "OK") {
            this.$toastr.s("Registro procesado con exito");
            this.returnPage();
          } else {
            this.$toastr.e(res.data);
          }
        })
        .catch(({ error }) => {});
    },
    cancelled() {
      this.deleteConfirmationModalActive = false;
    },
    
    openModal(evaluation) {
      this.$store.state.qualityManagement.evaluation = evaluation;
      this.openAddEditModal();
    },
    openAddEditModal() {
      this.isAddEditModalActive = true;
    },
    closeAddEditModal() {
      $("#director-area-modal").modal("hide");
      this.isAddEditModalActive = false;
      // this.reSetData();
    },
    getActivity() {
      axios
        .get(
          `/evaluator/documentaryEvaluation/activity/${this.accAppId}?accApp=1`
        )
        .then((res) => {
          this.$store.state.accreditation.id = res.data.id;
          this.$store.state.accreditation.app = res.data;
        });
    },
  }
};
</script>